import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import Button from "react-bootstrap/Button";

function handleLogin(instance) {
  instance.loginRedirect(loginRequest).catch((e) => {
    console.error(e);
  });
}

/**
 * Renders a button which, when selected, will open a popup for login
 */
export const SignInButton = () => {
  const { instance } = useMsal();

  return (
    <Button
      className="text-center my-3 w-100 login-btn"
      onClick={() => handleLogin(instance)}
    >
      Sign in
    </Button>
  );
};
